<div class="annotation-container">
  @for (annotation of annotationService.annotations(); track annotation.uuid) {
    @if (annotation.visible) {
      <div
        class="annotation"
        [class.highlighted]="annotation.highlighted"
        [style.left.px]="annotation.position.x"
        [style.top.px]="annotation.position.y"
        [style.z-index]="annotation.zIndex"
        [style.opacity]="annotation.opacity"
      >
        <div class="annotation-titlebar">
          <span class="annotation-label" (click)="onAnnotationTitleClick(annotation)">
            {{ annotation.title }}
          </span>
        </div>
        @if (annotation.descriptionVisible && annotation.description) {
          <div class="annotation-description">
            {{ annotation.description }}
          </div>
        }
      </div>
    }
  }
</div>
